import axios from 'axios'
import { BUSCAR_OPCOES_FILTROS_CONFIGURACAO_BILHETE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarOpcoesFiltrosConfiguracaoBilhete () {

  const url = `${URL}/config-bilhete/opcoes-filtro`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_OPCOES_FILTROS_CONFIGURACAO_BILHETE,
        payload: response

      })
  );
}
